import { render } from "./SideBarComp.vue?vue&type=template&id=071170e6"
import script from "./SideBarComp.vue?vue&type=script&lang=js"
export * from "./SideBarComp.vue?vue&type=script&lang=js"

import "./SideBarComp.vue?vue&type=style&index=0&id=071170e6&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__